/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContactUsRequest } from '@shared/types/common';

@Injectable({ providedIn: 'root' })
export class ContactUsApiService {
  constructor(private http: HttpClient) {}

  sendRequestWithFiles(data: ContactUsRequest, files: File[] = []) {
    const fd = new FormData();
    fd.append('req', JSON.stringify(data));
    files.forEach((file) => fd.append('files', file));
    return this.http.post<void>(`/api/v1/support/requests`, fd, { reportProgress: true, observe: 'events' });
  }
}
